module.exports = __webpack_public_path__ + "img/COX_Label_02.40470358.png";